import { match } from "ts-pattern";

import type { FormContextData } from "@thalamos/aspire-common";
import {
  applicationTemplateIds,
  formIsVoid,
  getLatestVersion,
  recordOfDetentionTemplateIds,
} from "@thalamos/aspire-common";

export function reviewableForms(
  formImWorkingOn: string | undefined,
  formContext: FormContextData,
) {
  const hasCompletedApplication = formContext.forms.some(
    (f) =>
      applicationTemplateIds.includes(f.formTemplate.id) &&
      match(f.status)
        .with("complete", "finalised", () => true)
        .with("in-progress", "deleted", () => false)
        .exhaustive(),
  );

  return (
    formContext.forms
      .filter(
        (f) =>
          getLatestVersion(f).signatures.length > 0 ||
          f.source === "manual-upload",
      )
      .filter(
        (f) =>
          // The form is the form on your work item (e.g. the form you're being asked to review, which may be a
          // med rec being completed after the application has been signed)
          f.id === formImWorkingOn ||
          // Don't filter any forms out if there's no completed application
          !hasCompletedApplication ||
          // Don't filter out any forms with links
          f.linkedForms.length > 0 ||
          // Don't filter out applications
          applicationTemplateIds.includes(f.formTemplate.id) ||
          // Don't filter out records of detention
          recordOfDetentionTemplateIds.includes(f.formTemplate.id),
      )
      .filter((f) => f.status !== "deleted")
      // A form superseded by a completed redo is never the current form, so it
      // is always excluded from the review/invite navigation — including when it
      // is the work-item form (e.g. a stale invite to a form since redone).
      .filter((f) => !formIsVoid(f))
      .sort((f1, f2) => (f1.updated < f2.updated ? 1 : -1))
  );
}
